import React, { useState, useEffect } from "react";
import ImageMapper from "react-image-mapper";
import moment from "moment";
import swal from "sweetalert2";
import "react-web-tabs/dist/react-web-tabs.css";
import apiService from "apiService";
import { showLoading, toast } from "view/component/Alert";

const BodyParts = (props) => {
  const [Areas, setAreas] = useState([]);
  const [select, setSelect] = useState("");
  const [selected, setSelected] = useState("");
  const [img, setImg] = useState([]);
  const [selectImgUrl, setSelectImgUrl] = useState("");
  const [selectImg, setSelectImg] = useState("");
  const [ref_WD, setRefWd] = useState([]);

  const setPoly = (e) => {
    let x = e.nativeEvent.offsetX;
    let y = e.nativeEvent.offsetY;
    const newAreas = Areas.map((object) => {
      if (object.id === selected) {
        if (object.shape === "poly") {
          return {
            ...object,
            coords: [...object.coords, x, y], //poly
            // coords : [x,y, 20] //circle
          };
        } else {
          return {
            ...object,
            // coords: [...object.coords, x, y] //poly
            coords: [x, y, 5], //circle
          };
        }
      } else return object;
    });
    setAreas(newAreas);
  };
  const onReload = () => {
    props.history.push("/pelayanan");
  };
  const handleChange = (e, idx) => {
    let val = e.target.value;
    let name = e.target.name;
    setAreas(
      [...Areas].map((object, index) => {
        if (object.id === selected) {
          return {
            ...object,
            [name]: val,
          };
        } else return object;
      })
    );
  };
  const handleGroupChange = (key, value) => {
    const newAreas = Areas.map((area) => ({
      ...area,
      group_name: area.group_key === key ? value : area.group_name,
    }));
    setAreas(newAreas);
  };
  const getBodyImage = async () => {
    let res = await apiService.get("/management/body-examination/read");
    if (res.code === 200) {
      setImg(res.data);
      setSelectImg(res.data[0].id);
      setSelectImgUrl(res.data[0].photo);
    }
  };
  const WoundDegree = async () => {
    let res = await apiService.get(
      "/management/wound-degree/read?clinic_id=" + props.patient.clinic_id
    );
    if (res.code === 200) {
      setRefWd(res.data);
    }
  };

  const GetWoundDegree = async (body_id, url1) => {
    let res = await apiService.get(
      "/registration/body-examination/read/visit/" +
        props.patient.id +
        "/" +
        body_id
    );
    if (res?.code === 200) {
      let shape = [];
      res.data.map((a, k) => {
        shape.push({
          id: a.id,
          name: a.name,
          shape: "circle",
          coords: a.coordinate?.split(","),
          preFillColor: a.color || a.wound_degree.color || "#32a852",
          wound_degree_id: a.wound_degree.id,
          body_id: a.body?.id,
          saved: true,
          group_key: a.group_key,
          group_name: a.group_name,
        });
      });
      setAreas(shape);
      if (shape.length > 0) {
        setSelected(shape[0].id);
        setSelect(shape[0].id);
      }
    } else {
      setAreas([
        {
          id: 1,
          name: "",
          shape: "circle",
          coords: [],
          preFillColor: "#32a852",
          wound_degree_id: 1,
          body_id: selectImg,
          saved: false,
          group_key: moment().unix(),
          group_name: "",
        },
      ]);
      setSelected(1);
    }
    setSelectImgUrl(url1);
  };
  const Post = async () => {
    showLoading("Menyimpan Gambar");
    let createBodyExm = [];
    let updateBodyExm = [];
    Areas.map((a) => {
      if (a.saved === false) {
        createBodyExm.push({
          visit_id: props.patient.id,
          wound_degree_id: a.wound_degree_id,
          name: a.name,
          coordinate: a.coords,
          body_id: selectImg,
          color: a.preFillColor,
          group_key: a.group_key,
          group_name: a.group_name,
        });
      } else {
        updateBodyExm.push({
          id: a.id,
          visit_id: props.patient.id,
          wound_degree_id: a.wound_degree_id,
          name: a.name,
          coordinate: a.coords,
          body_id: selectImg,
          color: a.preFillColor,
          group_key: a.group_key,
          group_name: a.group_name,
        });
      }
    });

    for (let index = 0; index < createBodyExm.length; index++) {
      const element = createBodyExm[index];
      let res = await apiService.post(
        "/registration/body-examination/create",
        element
      );
    }
    for (let index = 0; index < updateBodyExm.length; index++) {
      const element = updateBodyExm[index];
      let res = await apiService.put(
        "/registration/body-examination/update",
        element
      );
    }
    toast({ status: "success", text: "berhasil disimpan" });
  };

  useEffect(() => {
    getBodyImage();
    WoundDegree();
  }, [img.length]);
  useEffect(() => {
    if (selectImg !== "") {
      let url = img.find((a) => a.id === selectImg).photo;
      GetWoundDegree(selectImg, url);
    }
  }, [selectImg]);
  useEffect(() => {
    // if (select > 0) {
    //   let all = [...Areas];
    //   for (let index = 0; index < all.length; index++) {
    //     const element = all[index];
    //     if (element.preFillColor == "blue") {
    //       all[index].preFillColor = "#32a852";
    //     }
    //   }
    //   all[select - 1].preFillColor = "blue";
    //   setAreas(all);
    // }
  }, [select]);

  const groupedAreas = (data) => {
    return Object.values(
      data.reduce((acc, item) => {
        if (!acc[item.group_key]) {
          acc[item.group_key] = {
            group_key: item.group_key,
            group_name: item.group_name,
            data: [],
          };
        }
        acc[item.group_key].data.push(item);
        return acc;
      }, {})
    );
  };

  return (
    <div>
      <div className="card col-12">
        <div className="card-body">
          <div className="row">
            <div className="col-md-3">
              {/* List group */}
              <ul
                className="list-group list-group-flush"
                data-toggle="checklist"
              >
                {img.map((a, k) => (
                  <li
                    className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"
                    href="#"
                    key={k}
                    onClick={(e) => setSelectImg(a.id)}
                  >
                    <div
                      className={
                        selectImg === a.id
                          ? "checklist-item checklist-item-success"
                          : "checklist-item"
                      }
                    >
                      <div className="checklist-info">
                        <h5 className="checklist-title mb-0">{a.name}</h5>
                      </div>
                      <div>
                        <div className="custom-control custom-checkbox custom-checkbox-success">
                          <input
                            className="custom-control-input"
                            id={`chk-todo-task-${k}`}
                            name="body"
                            onChange={(e) => setSelectImg(a.id)}
                            type="radio"
                            checked={selectImg === a.id ? true : false}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`chk-todo-task-${k}`}
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4">
                                        <div className="checklist-item">
                                            <div className="checklist-info">
                                                <h5 className="checklist-title mb-0">Tangan</h5>
                                            </div>
                                            <div>
                                                <div className="custom-control custom-checkbox custom-checkbox-success">
                                                    <input className="custom-control-input" id="chk-todo-task-2"  name ='body' type="radio" defaultChecked={false} />
                                                    <label className="custom-control-label" htmlFor="chk-todo-task-2" />
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
              </ul>
            </div>
            <div className="col-md-9">
              <ImageMapper
                key={moment().unix()}
                src={selectImgUrl}
                map={{
                  name: "my-map",
                  areas: Areas,
                }}
                width={600}
                // imgWidth={600}
                responsive={true}
                lineWidth={4}
                onImageClick={async (e) => {
                  setPoly(e);
                }}
                onClick={(e) => {
                  swal
                    .fire({
                      title: "Hapus Titik",
                      text: `Group ${e.group_name} - Name ${e.name}`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Hapus",
                      cancelButtonText: "Cancel",
                    })
                    .then((result) => {
                      if (result.isConfirmed) {
                        // aksi konfirmasi
                        const newArea = Areas.filter(
                          (area) => area.id !== e.id
                        );
                        if (newArea.length > 0) {
                          setSelected(newArea[0].id);
                          setSelect(newArea[0].id);
                        }
                        setAreas(newArea);
                      }
                    });
                }}
              />
              <div className="d-flex my-4 justify-content-between">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => {
                    const id = (Math.random() + 1).toString(36).substring(7);
                    setAreas([
                      ...Areas,
                      {
                        id,
                        name: "",
                        shape: "circle",
                        coords: [],
                        preFillColor: "#32a852",
                        body_id: selectImg,
                        wound_degree_id: 1,
                        saved: false,
                        group_key: moment().unix(),
                        group_name: "",
                      },
                    ]);
                    setSelect(id);
                    setSelected(id);
                  }}
                >
                  Tambah Group
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => {
                    const id = (Math.random() + 1).toString(36).substring(7);
                    setAreas([
                      {
                        id,
                        name: "",
                        shape: "circle",
                        coords: [],
                        preFillColor: "#32a852",
                        body_id: selectImg,
                        wound_degree_id: 1,
                        saved: false,
                      },
                    ]);
                    setSelect(id);
                    setSelected(id);
                  }}
                >
                  Hapus Semua
                </button>
              </div>
              {groupedAreas(Areas).map((item) => (
                <div className="row border p-3" key={item.group_key}>
                  <div className="d-flex align-items-center mb-2">
                    <label className="text-sm mr-3">Group</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="name"
                      id="group_name"
                      name="group_name"
                      onChange={(e) =>
                        handleGroupChange(item.group_key, e.target.value)
                      }
                      value={item.group_name}
                    />
                  </div>
                  <div className="col-12">
                    {item.data.map((a, d) => (
                      <div className="row mb-1" key={d}>
                        <button
                          className={
                            select === a.id
                              ? "btn btn-sm btn-success"
                              : "btn btn-sm btn-secondary"
                          }
                          onClick={() => {
                            setSelect(a.id);
                            setSelected(a.id);
                          }}
                        >
                          Pilih
                        </button>
                        <input
                          className="form-control form-control-sm col-md-5"
                          type="text"
                          placeholder="name"
                          id="name"
                          name="name"
                          disabled={a.id !== selected}
                          onChange={(e) => handleChange(e)}
                          value={a.name}
                        />
                        <select
                          name="wound_degree_id"
                          className="form-control form-control-sm col-md-4"
                          disabled={a.id !== selected}
                          onChange={(e) => handleChange(e)}
                          value={a?.wound_degree_id}
                        >
                          <option value={0}> Pilih skala .... </option>
                          {ref_WD.map((d, k) => (
                            <option key={k + 1} value={d.id}>
                              {" "}
                              {d.name}{" "}
                            </option>
                          ))}
                        </select>
                        <input
                          className="form-control form-control-sm col-md-1"
                          type="color"
                          placeholder="preFillColor"
                          id="preFillColor"
                          name="preFillColor"
                          disabled={a.id !== selected}
                          onChange={(e) => handleChange(e)}
                          value={a.preFillColor}
                        />
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() =>
                            setAreas(Areas.filter((e) => e.name !== a.name))
                          }
                        >
                          x
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex mt-2">
                    <button
                      className="btn btn-sm btn-outline-success"
                      onClick={() => {
                        const id = (Math.random() + 1)
                          .toString(36)
                          .substring(7);
                        setAreas([
                          ...Areas,
                          {
                            id,
                            name: "",
                            shape: "circle",
                            coords: [],
                            preFillColor: "#32a852",
                            body_id: selectImg,
                            wound_degree_id: 1,
                            saved: false,
                            group_key: item.group_key,
                            group_name: item.group_name,
                          },
                        ]);
                        setSelect(id);
                        setSelected(id);
                      }}
                    >
                      Tambah
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => {
                        const newArea = Areas.filter(
                          (area) => area.group_key !== item.group_key
                        );
                        if (newArea.length > 0) {
                          setSelected(newArea[0].id);
                          setSelect(newArea[0].id);
                        }
                        setAreas(newArea);
                      }}
                    >
                      Hapus Group
                    </button>
                  </div>
                </div>
              ))}
              <div className="d-none">
                {Areas.map((a, d) => (
                  <div className="row mt-2" key={d}>
                    <button
                      className={
                        select === d + 1
                          ? "btn btn-sm btn-success"
                          : "btn btn-sm btn-secondary"
                      }
                      onClick={() => {
                        setSelect(d + 1);
                        setSelected(a.id);
                      }}
                    >
                      pilih
                    </button>
                    <input
                      className="form-control form-control-sm col-md-5"
                      type="text"
                      placeholder="name"
                      id="name"
                      name="name"
                      disabled={a.id !== selected}
                      onChange={(e) => handleChange(e)}
                      value={a.name}
                    />
                    <select
                      name="wound_degree_id"
                      className="form-control form-control-sm col-md-4"
                      disabled={a.id !== selected}
                      onChange={(e) => handleChange(e)}
                      value={a?.wound_degree_id}
                    >
                      <option value={0}> Pilih skala .... </option>
                      {ref_WD.map((d, k) => (
                        <option key={k + 1} value={d.id}>
                          {" "}
                          {d.name}{" "}
                        </option>
                      ))}
                    </select>
                    <input
                      className="form-control form-control-sm col-md-1"
                      type="color"
                      placeholder="preFillColor"
                      id="preFillColor"
                      name="preFillColor"
                      disabled={a.id !== selected}
                      onChange={(e) => handleChange(e)}
                      value={a.preFillColor}
                    />
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() =>
                        setAreas(Areas.filter((e) => e.name !== a.name))
                      }
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="row">
            <button className="btn btn-primary" onClick={() => Post()}>
              Simpan
            </button>
            <button className="btn btn-danger" onClick={() => onReload}>
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BodyParts;
